/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
/* eslint-disable react/react-in-jsx-scope */
import React,{useState,useCallback,useEffect, useRef, useContext} from 'react'
import CardHeader from '../../../../components/CardHeader'
import CustomeDatePicker from '../../../../components/DatePicker';
import { dataService } from '../../../../services/data.services';
import moment from 'moment'

import Toast from '../../../../components/Toast';
import { motion } from 'framer-motion';
import GlobalContext from '../../../../components/Context/GloablContext';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Loader from '../../../../components/Loader';
import { ConvertToTitleCase } from '../../../../CommonMethods/ConvertToTitleCase';
import ViewTerm from './ViewTerm';
import { CognitoData } from '../../../../CommonMethods/CognitoData';
import CustomOverLay from '../../../../components/CustomOverlay';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';

export default function AddFeeTerm({edit}) {
    const {id}=useParams(   )
    const {setToastmessage}=useContext(GlobalContext)
    const [submitSelected, setsubmitSelected] = useState(false);
    const [toastErrorMessage, setToastErrorMessage] = useState('');
    const [customError, setcustomError] = useState([]);
    const [searchParams, setSearchParams] =useSearchParams('')
    const location=useNavigate();
    const [InitialLoading, setInitialLoading] = useState(true)
    const [loading, setloading] = useState(false)
    const [editData, seteditData] = useState({})
    const [Ay, setAy] = useState([]);
    const [Edit, setEdit] = useState(false)
    const [showDropdown, setshowDropdown] = useState({
        'academic_year':false,
        'terms':false
    })
    const [focusedIndex, setFocusedIndex] = useState(-1);
    const [ayFocusedIndex, setAyFocusedIndex] = useState(-1);
    const termObj={
        "start_date":"",
        "end_date":"",
        "due_date":""
    }

    const initialState={
        "academic_year":{},
        "fee_term_name":"",
        "terms":{
            "term 1":termObj

        }
    }
    
    const [state,setstate]=useState(initialState)
    const termsDropdownRef = useRef(null);
    const termsButtonRef = useRef(null);
    const termsOptionsRef = useRef([]);
    const ayDropdownRef = useRef(null);
    const ayButtonRef = useRef(null);
    const ayOptionsRef = useRef([]);

    const handleDropdown=(key)=>{
        setsubmitSelected(false);

        setshowDropdown((prv)=>({
            ...prv,
            [key]:!showDropdown[key]
        }))

    }
    const ref = useRef(null);
    const ref2 = useRef(null);
 
    useOnClickOutside(ref, () => {
        setsubmitSelected(false);
        setshowDropdown({
            'academic_year':false,
            'terms':false
        })    
    });

    useOnClickOutside(ref2, () => {
        setsubmitSelected(false);
        setshowDropdown({
            'academic_year':false,
            'terms':false
        })  
    });

    useOnClickOutside(termsDropdownRef, () => {
        if (showDropdown.terms) {
            handleDropdown('terms')
            setFocusedIndex(-1)
        }
    });

    useOnClickOutside(ayDropdownRef, () => {
        if (showDropdown.academic_year) {
            handleDropdown('academic_year')
            setAyFocusedIndex(-1)
        }
    });

    useEffect(() => {
        if(showDropdown.terms){
            termsDropdownRef.current?.focus();
            return
        }
        if(showDropdown.academic_year){
            ayDropdownRef.current?.focus();
            return
        }
    }, [showDropdown.terms, showDropdown.academic_year]);

    useEffect(() => {
        if (focusedIndex !== -1 && termsOptionsRef.current[focusedIndex]) {
            termsOptionsRef.current[focusedIndex].scrollIntoView({
                block: 'nearest',
            });
        }
    }, [focusedIndex]);

    useEffect(() => {
        if (ayFocusedIndex !== -1 && ayOptionsRef.current[ayFocusedIndex]) {
            ayOptionsRef.current[ayFocusedIndex].scrollIntoView({
                block: 'nearest',
            });
        }
    }, [ayFocusedIndex]);

    const handleButtonKeyDown = (e) => {
        if ((e.key === 'Enter' || e.key === 'Return' || e.key === 'ArrowDown') && !showDropdown.terms) {
            e.preventDefault();
            handleDropdown('terms')
        }
    };

    const handleAyButtonKeyDown = (e) => {
        if ((e.key === 'Enter' || e.key === 'Return' || e.key === 'ArrowDown') && !showDropdown.academic_year) {
            e.preventDefault();
            handleDropdown('academic_year')
        }
    };

    const handleListKeyDown = (e) => {
        e.stopPropagation();

        if (e.key === 'Escape' || e.key === 'Tab') {
            e.preventDefault();
            handleDropdown('terms');
            setFocusedIndex(-1);
            termsButtonRef.current?.focus();
            return;
        }
        const optionsLength = 12;
        if (optionsLength > 0) {
            switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                setFocusedIndex((prevIndex) =>
                    prevIndex < optionsLength - 1 ? prevIndex + 1 : 0
                );
                break;
            case 'ArrowUp':
                e.preventDefault();
                setFocusedIndex((prevIndex) =>
                    prevIndex > 0 ? prevIndex - 1 : optionsLength - 1
                );
                break;
            case 'Enter':
            case 'Return':
                e.preventDefault();
                if (focusedIndex !== -1) {
                    handleterms(focusedIndex + 1, 'terms');
                    setFocusedIndex(-1);
                    termsButtonRef.current?.focus();
                } else {
                    handleDropdown('terms');
                    setFocusedIndex(-1);
                    termsButtonRef.current?.focus();
                }
                break;
            default:
                break;
            }
        } else if (e.key === 'Enter' || e.key === 'Return') {
            e.preventDefault();
            handleDropdown('terms');
            setFocusedIndex(-1);
            termsButtonRef.current?.focus();
        }
    };

    const handleAyListKeyDown = (e) => {
        e.stopPropagation();

        if (e.key === 'Escape' || e.key === 'Tab') {
            e.preventDefault();
            handleDropdown('academic_year');
            setAyFocusedIndex(-1);
            ayButtonRef.current?.focus();
            return;
        }
        const optionsLength = Ay.length;
        if (optionsLength > 0) {
            switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                setAyFocusedIndex((prevIndex) =>
                    prevIndex < optionsLength - 1 ? prevIndex + 1 : 0
                );
                break;
            case 'ArrowUp':
                e.preventDefault();
                setAyFocusedIndex((prevIndex) =>
                    prevIndex > 0 ? prevIndex - 1 : optionsLength - 1
                );
                break;
            case 'Enter':
            case 'Return':
                e.preventDefault();
                if (ayFocusedIndex !== -1) {
                    handleInput('academic_year', Ay[ayFocusedIndex]);
                    setAyFocusedIndex(-1);
                    ayButtonRef.current?.focus();
                } else {
                    handleDropdown('academic_year');
                    setAyFocusedIndex(-1);
                    ayButtonRef.current?.focus();
                }
                break;
            default:
                break;
            }
        } else if (e.key === 'Enter' || e.key === 'Return') {
            e.preventDefault();
            handleDropdown('academic_year');
            setAyFocusedIndex(-1);
            ayButtonRef.current?.focus();
        }
    };

    const getAy=useCallback(
        async() => {
            const branch_id = await GetBranchId()
            try {
                const res= await dataService.GetAPI(`academic-years?page_number=1&filter=true&status=ongoing,upcoming&branch_id=${branch_id}`);
                setAy(res.data.data.data);
                setInitialLoading(false);
                
            } catch (error) {
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
                setInitialLoading(false)
            }
        },
        [],
    )
    const GetFeeterm=useCallback(
        async() => {
            const branch_id = await GetBranchId()
            try {
                const res= await dataService.GetAPI(`feeterms/${id}`);
                seteditData(res.data.data);
                setstate((prv)=>({
                    ...prv,
                    "fee_term_name":res.data.data.fee_term_name
                }))
                setInitialLoading(false)
            } catch (error) {
                location('/404')
                setInitialLoading(false)
            }
        },
        [],
    )
    
    useEffect(() => {
        if(edit){
            GetFeeterm()
        }else{
            getAy()

        }
       
    }, [getAy,GetFeeterm])
    
    const handleterms=(key,val)=>{
        let obj={}
        const copy=[...Array(parseInt(key))].map((val,i)=>{
            obj[`Term ${i+1}`]={};
            obj[`Term ${i+1}`].start_date='';
            obj[`Term ${i+1}`].end_date='';
            obj[`Term ${i+1}`].due_date=''
        })
        setstate((prv)=>({
            ...prv,
            terms:obj
        }));
        handleDropdown(val)

    }
    const handleClear=(key)=>{
        const term = parseInt(key.split(' ')[1]);
        setsubmitSelected(false);
        const copy={...state};

        if (Number(term) === 1) {            
            // Set all values to empty for term 1
            copy.terms[key] = { ...termObj };
        } else {
            // clear only end_date and due_date for other terms
            copy.terms[key] = {
                ...copy.terms[key],
                end_date: "",
                due_date: ""
            };
        }     
        
        const nextTerm = `Term ${term + 1}`;
        if (nextTerm in copy.terms) {
            copy.terms[nextTerm]['start_date'] = "";
        }   

        console.log(copy)
        setstate(copy)
    }
   
    const handleSelect = (id, date, dateString, termName) => {
        if (Object.keys(state.academic_year)?.length === 0) {
            setToastErrorMessage("Please select the academic year.");
            return;
        }
    
        const staterep = { ...state };
        setToastErrorMessage('');
        setsubmitSelected(false);

        const startDate = staterep.terms[termName]['start_date'];
        const dueDate = staterep.terms[termName]['due_date'];
        const endDate = staterep.terms[termName]['end_date'];
        const nextTerm = `Term ${parseInt(termName.split(' ')[1]) + 1}`;
    
        // Check if the date is within the academic year
        if (id !== 'due_date' &&
            (!moment(dateString).isSameOrAfter(moment(state?.academic_year['start_date']?.split('T')[0]).format('MMM DD, YYYY')) ||
                !moment(dateString).isSameOrBefore(moment(state?.academic_year['end_date']?.split('T')[0]).format('MMM DD, YYYY')))) {
            setToastErrorMessage("Start date and end date must be within the academic year.");
            staterep.terms[termName][id] = '';
            return;
        }
    
        if (id === 'start_date' && staterep.terms[termName]['end_date'] !== '' &&
            !moment(dateString).isSameOrBefore(moment(staterep.terms[termName]['end_date']))) {
            staterep.terms[termName]['end_date'] = '';
        }

        if (id === 'due_date')
        {
            if (dueDate && moment(dateString).isBefore(moment(endDate))) {
                // Clear the end date and show an error message
                staterep.terms[termName]['due_date'] = '';
                setToastErrorMessage("Due date must be after the end date.");
                setstate(staterep);
                return;
            }
        }
    
        if (id === 'start_date') {
    
            // Prevent start date from being the same as the end date
            if (endDate && moment(dateString).isSame(moment(endDate))) {
                setToastErrorMessage("Start date cannot be the same as the end date.");
                staterep.terms[termName]['start_date'] = '';
                return;
            }
    
            // Clear the end date if the start date exceeds it
            if (endDate && moment(dateString).isAfter(moment(endDate))) {
                staterep.terms[termName]['end_date'] = '';
                setToastErrorMessage("Start date cannot exceed the end date.");
            }
    
            // Set the start date
            staterep.terms[termName]['start_date'] = dateString;
        }
    
        if (id === 'end_date') {
    
            // Check if the end date exceeds the start date
            if (startDate && moment(dateString).isBefore(moment(startDate))) {
                // Clear the end date and show an error message
                staterep.terms[termName]['end_date'] = '';
                setToastErrorMessage("End date cannot be before the start date.");
                setstate(staterep);
                return;
            }
    
            // Prevent end date from being the same as the start date
            if (startDate && moment(dateString).isSame(moment(startDate))) {
                setToastErrorMessage("Start date and end date cannot be the same.");
                staterep.terms[termName][id] = '';
                return;
            }
    
            // Set the end date
            staterep.terms[termName]['end_date'] = dateString;

            //set the due date
            staterep.terms[termName]['due_date'] = dateString;

            //set the next term's start date    
            if(nextTerm in staterep.terms)
            {
                const nextDate = new Date(dateString);
                nextDate.setDate(nextDate.getDate() + 1);
                staterep.terms[nextTerm]['start_date'] = nextDate.toDateString();
            }
        }
    
        if (disabledDate(moment(dateString))) {
            setToastErrorMessage("Start date and end date must be within the academic year.");
            staterep.terms[termName][id] = '';
            return;
        }
    
        if (id === 'end_date' &&
            !moment(dateString).isSameOrBefore(moment(state?.academic_year?.end_date?.split('T')[0]).format('MMM DD, YYYY'))) {
            setToastErrorMessage("End date must be within the academic year.");
            staterep.terms[termName][id] = '';
            return;
        }
    
        // Check if start date and end date are the same (already handled above)
        
        // Check if end date of the previous term exceeds start date of the current term
        const prevTerm = `Term ${parseInt(termName.split(' ')[1]) - 1}`;
        if (id === 'start_date' && prevTerm in staterep.terms) {
            const prevEndDate = staterep.terms[prevTerm]['end_date'];
            if (prevEndDate && moment(dateString).isBefore(moment(prevEndDate))) {
                setToastErrorMessage("Start date of the current term cannot be before the end date of the previous term.");
                staterep.terms[termName][id] = '';
                return;
            }
    
            // **New Condition: Start date cannot be the same as the end date of the previous term**
            if (prevEndDate && moment(dateString).isSame(moment(prevEndDate))) {
                setToastErrorMessage("Start date of the current term cannot be the same as the end date of the previous term.");
                staterep.terms[termName][id] = '';
                return;
            }
        }
    
        // Ensure the start date is not less than the start or end date of the previous term
        if (id === 'start_date' && prevTerm in staterep.terms) {
            const prevStartDate = staterep.terms[prevTerm]['start_date'];
            const prevEndDate = staterep.terms[prevTerm]['end_date'];
            if (prevStartDate && (moment(dateString).isSameOrBefore(moment(prevStartDate)) || 
                (prevEndDate && moment(dateString).isBefore(moment(prevEndDate))))) {
                setToastErrorMessage("Start date of the current term cannot be less than the start or end date of the previous term.");
                staterep.terms[termName][id] = '';
                return;
            }
        }
    
        // Ensure end date does not exceed the start date of the next term (but can be the same)
        
        if (id === 'end_date' && nextTerm in staterep.terms) {
            const nextStartDate = staterep.terms[nextTerm]['start_date'];
            if (nextStartDate && moment(dateString).isAfter(moment(nextStartDate))) {
                setToastErrorMessage("End date of the current term cannot exceed the start date of the next term.");
                staterep.terms[termName][id] = '';
                return;
            }
    
            if (nextStartDate && moment(dateString).isSame(moment(nextStartDate))) {
                setToastErrorMessage("End date of the current term cannot be the same as the start date of the next term.");
                staterep.terms[termName][id] = '';
                return;
            }
    
        }
    
        // Clear all subsequent start dates that are less than the current start date
        if (id === 'start_date' && nextTerm in staterep.terms) {
            let currentStartDate = moment(dateString);
            let termIndex = parseInt(termName.split(' ')[1]) + 1;
            while (`Term ${termIndex}` in staterep.terms) {
                const nextTermStartDate = staterep.terms[`Term ${termIndex}`]['start_date'];
                if (nextTermStartDate && moment(nextTermStartDate).isBefore(currentStartDate)) {
                    staterep.terms[`Term ${termIndex}`]['start_date'] = '';
                }
                termIndex++;
            }
        }
    
        staterep.terms[termName][id] = dateString;
        setstate(staterep);
    };
    
    
   
    const handleInput=(key,val)=>{
        setToastErrorMessage('')
        setsubmitSelected(false);

        setstate((prv)=>({
            ...prv,
            [key]:val
        }));
        setshowDropdown((prv)=>({
            ...prv,
            [key]:false
        }))    }
    
    const handleError=(val)=>{
        if(submitSelected && val===''){
            return true
        }
        return false
    }
    
    const disabledDate = (current) => {
        return   current && (current < moment(`${state?.academic_year?.start_date?.split('T')[0]}`).format('MMM DD, YYYY') || current > moment(`${state?.academic_year?.end_date?.split('T')[0]}`).format('MMM DD, YYYY')); 
        
        
    };
    const handleValidation=()=>{
        let arr=[]
        if(state.academic_year===''){
            arr.push('academic_year')

        }
        if(state.fee_term_name===''){
            arr.push('fee_term_name')

        }
        Object.keys(state.terms).map((val)=>{
            Object.keys(state.terms[val]).map((key)=>{
                if(state.terms[val][key]===''){
                    arr.push(key)
                }
            })
        })
        return arr?.length===0
    }

    const createPayload= async()=>{
        const branch_id = await GetBranchId()
        let payload={
            "academic_year": {
                "name": state.academic_year.name,
                "start_date": state.academic_year.start_date,
                "end_date": state.academic_year.end_date,
                "academic_year_id" : state.academic_year._id
            },
            "fee_term_name": state.fee_term_name.trim(),
            "number_of_fee_terms": Object.keys(state.terms)?.length,
            "branch_id": branch_id

        }
        let obj=[]
        Object.keys(state.terms).map((val)=>{

            obj.push({
                "start_date": moment(state.terms[val].start_date).format("YYYY-MM-DD"),
                "end_date": moment(state.terms[val].end_date).format("YYYY-MM-DD"),
                "due_date": moment(state.terms[val].due_date).format("YYYY-MM-DD")
            })
        })    
        payload.terms=obj;
        return payload
    }
    const handleSubmit=async()=>{
        const queryString = window.location.search;
        const searchParams = new URLSearchParams(queryString);
        setloading(true)
        setsubmitSelected(true);
        if(edit==undefined && !handleValidation()){
            setToastErrorMessage("Please fill in all the mandatory fields") 
            setloading(false)
            return
        }
        if(edit && state.fee_term_name===''){
            setToastErrorMessage("Please fill in all the mandatory fields") 
            setloading(false)
            return        }
        
        try {
            let endpoint;
            let Payload
            if(edit==undefined){
                Payload = await createPayload()

            }
            let response
            const branch_id = await GetBranchId()
            if(edit) {
                const body={
                    "fee_term_name":state.fee_term_name.trim(),
                    "branch_id" : branch_id
                }
                endpoint=`feeterms/${id}`
                response = await dataService.PatchAPI(body,endpoint);
            } else {
                endpoint=`feeterms`
                let body = Payload
                body["branch_id"] = branch_id
                body["fee_term_name"] = Payload.fee_term_name.trim()
                response = await dataService.PostAPI(body,endpoint);
            }
            if (response.data.status===201 || response.error === false) {
                // dispatch(hanldeBranch(JSON.parse(CognitoCurrent["custom:branches"])))
                setToastmessage(`Fee term ${edit ? 'updated': 'added'} successfully`)
                setloading(false);
                if(edit){
                    location(`/fee-management/fee-terms/view-fee-term/${id}?${searchParams.toString()}`);
                    setEdit(false)
                }else{
                    location('/fee-management/fee-terms');
                }

            }
            else {
                setloading(false);
                setToastErrorMessage(response?.data?.data?.message || 'Something went wrong')

            }
        } catch (error) {
            setloading(false);
            setToastErrorMessage(error?.response?.data?.message || 'Something went wrong')

        }

    }

    const handleTitle=(key)=>{
        return Object.keys(state.academic_year)?.length>0 || key!==undefined?`${moment(state.academic_year.start_date).utcOffset('+00:00').format('MMM DD, YYYY')}-${moment(state.academic_year.end_date).utcOffset('+00:00').format('MMM DD, YYYY')}`:'';
    }
    return (
        <CardHeader noPadding>
            {toastErrorMessage!=='' &&<Toast
                message={toastErrorMessage}
                type="error"
                setToastmessage={setToastErrorMessage} />}
            <div className="mainDataCntnrTop shadow-s13" style={{position: '-webkit-sticky'}}>
                <div className='flex items-center'>

                    {edit && <a href="javascript:void(0)" onClick={()=>location(`/fee-management/fee-terms?${searchParams.toString()}`)}>
                        <img loading="lazy" decoding="async" src="/images/back-btnBlue.svg" alt="icon" />
                    </a>}
                
                    <h5 className={`pageHeader adderror ${edit?'ml-2.5':''}`}>{edit?'Fee Term Details':`Add Fee Term`}</h5>
                </div>
                {edit===undefined &&<div className="flex items-center">
                    <button onClick={()=>location('/fee-management/fee-terms')} type="button" className="cancl-btn">
                        Cancel 
                    </button>
                    <button 
                        disabled={ loading || (edit&&Object.keys(editData)?.length===0)}
                        type="button"
                        onClick={()=>handleSubmit()}
                        id='sumbit-button'
                        class="actn-btn onboardInstitution">
                        {!loading?edit?'Update':'Add':<span>{<Loader />}</span>}   
                    </button> 
                
                </div>}
                
            </div>
            {edit && Object.keys(editData)?.length===0?
                <>
                    {<CustomOverLay Active text="Loading..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}/>
                    }
                </>
                :
                edit?<ViewTerm 
                    Edit={Edit}
                    setEdit={setEdit}
                    editData={editData}
                    submitSelected={submitSelected}
                    state={state}
                    handleError={handleError}
                    handleInput={handleInput}
                    setsubmitSelected={setsubmitSelected}
                    handleSubmit={handleSubmit}
                />:<div>
                    
                    <div className="mainDataCntnrPageDiv scrollBlue_thick">
                        <div className="display">
                            <div className="xl:w-[70%] 2xl:w-[70%] mx-auto">
                                <div className="border border-[#D0D5DD] p-3 rounded">
                                    <div className="flex -mx-10">
                                        <div className="px-10 w-1/2">
                                            <div className="w-full">
                                                <div className="flex items-center w-full mb-4">
                                                    <label htmlFor="bname" className="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">Academic Year</label>
                                                    <div className="relative w-full" data-te-dropdown-ref>
                                                        <button ref={ayButtonRef} onKeyDown={handleAyButtonKeyDown} title={handleTitle()} onClick={()=>handleDropdown('academic_year')} className={`slct-inpt-fld transition duration-150 ease-in-out pr-[30px] ${!handleError(Object.keys(state['academic_year'])?.length===0?'':'val')?'':'redBorder'}`} type="button" id="dropdownMenu_acdemic_year" data-te-dropdown-toggle-ref aria-expanded="false">
                                                            <p className={`text-f7 ${Object.keys(state.academic_year)?.length>0?'text-[#031624]':'text-[#818E98]'} font-normal `}>
                                                                {Object.keys(state.academic_year)?.length===0?'Select Year':state.academic_year?.name } 
                                                                {Object.keys(state.academic_year)?.length>0 && `(${handleTitle()})`}
                                                            </p>
                                                            <img src="/images/dropdown-icon.png" alt="icon" className={`absolute  top-[50%] -translate-y-[50%] dropdown-close right-4  ${Ay?.length>0 &&showDropdown.academic_year ? "transform rotate-180":''} `} />
                                                        </button>
                                                        <ul onKeyDown={handleAyListKeyDown} tabIndex="-1" ref={ayDropdownRef} className={`ant-picker-dropdown slct_drp_dwn min-w-full ${showDropdown.academic_year?'':'hidden'}`} style={{outline: 'none'}} aria-labelledby="dropdownMenu_acdemic_year" data-te-dropdown-menu-ref>
                                                            <li className="max-h-[150px] overflow-auto scroll-bar">
                                                                <ul>
                                                                    {showDropdown.academic_year && Ay?.length > 0 ? Ay.map((val, i) => (
                                                                        <li key={val["_id"]} ref={el => ayOptionsRef.current[i] = el} className={`${ayFocusedIndex === i ? 'bg-gray-100' : ''}`} title={ val?.start_date ? `${val?.name} (${moment(val?.start_date).utcOffset('+00:00').format('MMM DD, YYYY')}- ${moment(val?.end_date).utcOffset('+00:00').format('MMM DD, YYYY')}) (${val?.status?.charAt(0)?.toUpperCase() + val?.status?.slice(1)})` : val?.name}
                                                                            onClick={() => {handleInput('academic_year', val); setAyFocusedIndex(-1)}}>
                                                                            <a className="w-full whitespace-nowrap bg-transparent pr-2 mb-3 text-f7 font-normal text-[#031624]" style={{ display: 'flex', alignItems: 'center' }} href="#" data-te-dropdown-item-ref>
                                                                                {state.academic_year.name === val.name
                                                                                    ? <img src="/images/bluedot.svg" alt="selected" className="mr-2 shrink-0"/>
                                                                                    : <div className="w-[7px] h-[6px] mr-2 shrink-0"></div>
                                                                                }
                                                                                <>{val?.name } <>({moment(val?.start_date).utcOffset('+00:00').format('MMM DD, YYYY')}-{moment(val?.end_date).utcOffset('+00:00').format('MMM DD, YYYY')}) ({val?.status?.charAt(0)?.toUpperCase() + val?.status?.slice(1)})</></>
                                                                            </a>
                                                                        </li>
                                                                    )) :
                                                                        (<li
                                                                            key=""
                                                                            id="select-option"
                                                                            onClick={(e) => {
                                                                                setshowDropdown(false);
                                                                            }}
                                                                        >
                                                                            <a className="slct_drp_dwn_optn">
                                                                                - No options available -
                                                                            </a>
                                                                        </li>)
                                                                    }
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="px-10 w-1/2">
                                            <div className="w-full">
                                                <div className="flex items-center mb-4">
                                                    <label htmlFor="fee_term_name" className="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">Fee Term Name</label>
                                                    <input 
                                                        type="text" 
                                                        maxlength={30}
                                                        id="fee_term_name" 
                                                        autoComplete='off'
                                                        onFocus={()=>setsubmitSelected(false)}
                                                        onChange={(e)=>handleInput('fee_term_name',e.target.value)}
                                                        className={`${(!handleError(state.fee_term_name)) ? '':'redBorder'} w-full inpt-fld error_border`}
                                                        placeholder="Enter Fee Term Name" />
                                                </div>
                                                <div className="flex items-center">
                                                    <label htmlFor="bname" className="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">No. of Fee Terms</label>
                                                    <div className="relative w-full" data-te-dropdown-ref>
                                                        <button ref={termsButtonRef} onKeyDown={handleButtonKeyDown} onClick={()=>handleDropdown('terms')} className="slct-inpt-fld duration-150 ease-in-out error_border" type="button" id="dropdownMenu_acdemic_year" data-te-dropdown-toggle-ref aria-expanded="false">
                                                            <p className="text-f7 text-[#031624] font-normal">{Object.keys(state.terms)?.length>0?Object.keys(state.terms)?.length:'Select No. of Terms'}</p>
                                                            <img src="/images/dropdown-icon.png" alt="icon" className={`absolute top-[50%] -translate-y-[50%] dropdown-close right-3 ${showDropdown.terms ? "transform rotate-180":''}`} />
                                                        </button>
                                                        <ul ref={termsDropdownRef} tabIndex="-1" onKeyDown={handleListKeyDown} className={`ant-picker-dropdown slct_drp_dwn min-w-full ${showDropdown.terms?'':'hidden'}`} style={{outline: 'none'}} aria-labelledby="dropdownMenu_acdemic_year" data-te-dropdown-menu-ref>
                                                            <li className="max-h-[150px] overflow-auto scroll-bar">
                                                                <ul>
                                                                    {[...Array(12)].map((val,i)=>(
                                                                        <li key={val} ref={el => termsOptionsRef.current[i] = el} className={`${focusedIndex === i ? 'bg-gray-100' : ''}`} onClick={()=>{handleterms(i+1,'terms'), setFocusedIndex(-1)}}>
                                                                            <p className="block w-full whitespace-nowrap bg-transparent pr-2 mb-3 text-f7 font-normal text-[#031624]" style={{ display: 'flex', alignItems: 'center' }} href="#" data-te-dropdown-item-ref>
                                                                                {Object.keys(state.terms)?.length === i+1
                                                                                    ? <img src="/images/bluedot.svg" alt="selected" className="mr-2 shrink-0"/>
                                                                                    : <div className="w-[7px] h-[6px] mr-2 shrink-0"></div>
                                                                                }
                                                                                {i+1}
                                                                            </p>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {state.academic_year!=='' &&
                                <motion.div
                                    initial={{ opacity: 0, y: -20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -20 }}
                                    className="xl:w-[80%] 2xl:w-[75%] mx-auto mt-10 added_feeTerm border border-[#E6E8EA]">
                                    <div className="flex w-full items-center px-2 p-2 formHeaderbg ">
                                        <div className="min-w-[100px] max-w-[100px]" />
                                        <div className="flex items-center -mx-10 w-[90%]">
                                            <div className="w-1/3 px-10">
                                                <div className="w-full">
                                                    <p className="font-semibold text-f7 text-[#031624] class-name-error">Start Date</p>
                                                </div>
                                            </div>
                                            <div className="w-1/3 px-10">
                                                <div className="w-full">
                                                    <p className="font-semibold text-f7 text-[#031624] class-name-error">End Date</p>
                                                </div>
                                            </div>
                                            <div className="w-1/3 px-10">
                                                <div className="w-full">
                                                    <p className="font-semibold text-f7 text-[#031624] class-name-error">Due Date</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex items-center -mx-10 w-[9%]"></div>
                                        <div className="ml-4 min-w-[63px]" />
                                    </div>
                                    {Object.keys(state.terms).map((term,i)=>(
                                        <motion.div
                                            initial={{ opacity: 0, y: -20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, y: -20 }} className="font-normal flex w-full items-center px-2 pb-3.5 pt-3 border-t border-[#E6E8EA]" key={term}>
                                            <div className="min-w-[100px] max-w-[100px]">{ConvertToTitleCase(term)}</div>
                                            <div className="flex items-center -mx-10 w-[90%]">
                                                <div className="w-1/3 px-10">
                                                    <CustomeDatePicker
                                                        id="start_date"
                                                        showErrorBorder={handleError(state.terms[term]['start_date'])}
                                                        format="MMM DD, YYYY"
                                                        state={state.terms[term]}
                                                        placeholder="Select Start Date"
                                                        handleSelect={handleSelect}
                                                        setdateError={setsubmitSelected}
                                                        termkey={term}
                                                        disabledDate={i>0}
                                                        imageClass
                                                    />
                                           
                                                </div>
                                                <div className="w-1/3 px-10">
                                                    <CustomeDatePicker
                                                        id="end_date"
                                                        showErrorBorder={handleError(state.terms[term]['end_date'])}
                                                        format="MMM DD, YYYY"
                                                        state={state.terms[term]}
                                                        placeholder="Select End Date"
                                                        handleSelect={handleSelect}
                                                        setdateError={setsubmitSelected}
                                                        termkey={term}
                                                        imageClass
                                                    />
                                                </div>
                                                <div className="w-1/3 px-10">
                                                    <CustomeDatePicker
                                                        id="due_date"
                                                        showErrorBorder={handleError(state.terms[term]['due_date'])}
                                                        format="MMM DD, YYYY"
                                                        state={state.terms[term]}
                                                        placeholder="Select Due Date"
                                                        handleSelect={handleSelect}
                                                        setdateError={setsubmitSelected}
                                                        termkey={term}
                                                        imageClass
                                                    />
                                                </div>
                                            </div>
                                            <div className="ml-4 min-w-[63px] w-[9%]">
                                                <button onClick={()=>handleClear(term)} className="list-actn-btn">
                                                    Clear
                                                </button>
                                            </div>
                                        </motion.div>
                                    ))}

                                </motion.div>}
                        </div>
                    </div></div >}
        </CardHeader>
    )
}